
ko.bindingHandlers.textBool = {
    /**
     *  
     * @param {HTMLBaseElement} element
     * @param {any} valueAccessor
     * @param {any} allBindings
     * @param {any} viewModel
     * @param {any} bindingContext
     */
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        element.textContent = ko.unwrap(valueAccessor()) ? 'Yes' : 'No';
    }
};